"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1061],{

/***/ 68085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ email_confirmed_error; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var dist_index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./src/theme/card/index.js
var card = __webpack_require__(16850);
// EXTERNAL MODULE: ./src/theme/buttons/btn.js
var btn = __webpack_require__(84146);
;// CONCATENATED MODULE: ./src/theme/icons/email-error.js


var emailError = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "168",
        height: "130",
        viewBox: "0 0 168 130",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_ddd)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        opacity: "0.4",
                        d: "M131.644 80.5718C132.068 79.4239 83.4522 42.5966 83.4522 42.5966C77.3658 38.0906 74.1647 38.0197 68.146 42.5966C68.146 42.5966 19.6012 79.3942 20.0098 80.5263L20 80.5346C20.005 80.5445 20.0131 80.5512 20.0199 80.5602C20.4315 81.686 21.0303 82.7336 21.791 83.6585C22.1123 84.0494 22.4995 84.3768 22.8719 84.7171L22.8538 84.7311C22.8835 84.7576 22.923 84.7699 22.9526 84.7963C24.5309 86.2088 26.5213 87.1236 28.7324 87.3847C28.7671 87.3889 28.7951 87.407 28.8297 87.4112H28.9632C29.2994 87.4434 29.619 87.5243 29.9632 87.5243H121.743C126.262 87.5243 130.091 84.6731 131.612 80.6762C131.63 80.6464 131.658 80.625 131.674 80.5943L131.644 80.5718Z",
                        fill: "#4CADBA"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        opacity: "0.6",
                        d: "M75.8661 38.3702L20.2565 80.2124V20.9361C20.2565 15.1584 24.9242 10.4756 30.6833 10.4756H121.049C126.808 10.4756 131.476 15.1584 131.476 20.9361V80.2124L75.8661 38.3702Z",
                        fill: "#B0DAE0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.9051 17.2995L68.3838 54.7123C74.3763 59.1486 77.5281 59.2187 83.4541 54.7123L130.858 17.3588C130.036 15.8631 128.805 14.6815 127.396 13.7394L128.049 13.2268C126.457 11.7734 124.423 10.8313 122.165 10.5879L29.571 10.5912C27.3193 10.8313 25.2818 11.7767 23.6937 13.2268L24.3409 13.733C22.9491 14.6621 21.7293 15.8233 20.9051 17.2995Z",
                        fill: "#EDECE6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.8896 17.3768C20.4727 18.5071 68.3393 54.7668 68.3393 54.7668C74.3318 59.2032 77.4836 59.2732 83.4096 54.7668C83.4096 54.7668 131.206 18.5365 130.804 17.4216L130.814 17.4135C130.809 17.4037 130.801 17.3973 130.794 17.3884C130.389 16.2799 129.799 15.2485 129.05 14.3378C128.734 13.9528 128.353 13.6307 127.986 13.2954L128.004 13.2816C127.975 13.2555 127.936 13.2433 127.907 13.2172C126.353 11.8266 124.393 10.9258 122.216 10.6687C122.182 10.6645 122.155 10.6468 122.121 10.6426H121.989C121.658 10.6109 121.343 10.5312 121.004 10.5312H30.639C26.1893 10.5312 22.4192 13.3387 20.9221 17.2739C20.9042 17.3032 20.8767 17.3245 20.8604 17.3544L20.8896 17.3768Z",
                        fill: "#E0F1F3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "114.014",
                        y: "65.3008",
                        width: "33.6",
                        height: "33.7087",
                        rx: "16.8",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M144.814 82.1553C144.814 89.8871 138.546 96.1553 130.814 96.1553C123.082 96.1553 116.814 89.8871 116.814 82.1553C116.814 74.4235 123.082 68.1553 130.814 68.1553C138.546 68.1553 144.814 74.4235 144.814 82.1553ZM130.814 93.6098C132.318 93.6098 133.807 93.3135 135.197 92.7379C136.587 92.1622 137.85 91.3185 138.913 90.2549C139.977 89.1912 140.821 87.9285 141.396 86.5387C141.972 85.149 142.268 83.6595 142.268 82.1553C142.268 80.651 141.972 79.1615 141.396 77.7718C140.821 76.3821 139.977 75.1193 138.913 74.0557C137.85 72.992 136.587 72.1483 135.197 71.5727C133.807 70.997 132.318 70.7007 130.814 70.7007C127.776 70.7007 124.862 71.9075 122.714 74.0557C120.566 76.2038 119.359 79.1173 119.359 82.1553C119.359 85.1932 120.566 88.1067 122.714 90.2549C124.862 92.403 127.776 93.6098 130.814 93.6098ZM132.086 74.5189V84.7007H129.541V74.5189H132.086ZM132.086 87.2462V89.7916H129.541V87.2462H132.086Z",
                        fill: "#B44B3D"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter0_ddd",
                    x: "0",
                    y: "0.475586",
                    width: "167.614",
                    height: "128.534",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            stdDeviation: "0.5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                            dy: "2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            stdDeviation: "3"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in2: "effect1_dropShadow",
                            result: "effect2_dropShadow"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                            dy: "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            stdDeviation: "10"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in2: "effect2_dropShadow",
                            result: "effect3_dropShadow"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect3_dropShadow",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var email_error = (emailError);

// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
;// CONCATENATED MODULE: ./src/components/email-confirmed-error/index.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  width: 100%;\n  min-height: 100%;\n\n  & > div > .row-2 {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  & > div > .row-2 > div {\n    display: flex;\n    flex-direction: row;\n  }\n\n  & > div > .row-2 > div > .col-2 {\n    display: flex;\n    flex-direction: column;\n    max-width: 360px;\n    justify-content: center;\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-edd7a693-0"
})(_templateObject(), index_esm/* flexbox */.GQ, index_esm/* space */.Dh, (0,dist_index_esm/* themeGet */.R)("space.m"));
var Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-edd7a693-1"
})(_templateObject1(), index_esm/* typography */.cp, index_esm/* color */.$_, index_esm/* space */.Dh);
function EmailConfirmedError(param) {
    var onClose = param.onClose;
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
            width: "100%",
            minWidth: "240px",
            bg: "white",
            borderColor: "primary_100",
            py: "l",
            px: "s",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(email_error, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        fontSize: "h2",
                                        lineHeight: "h2",
                                        fontWeight: "bold",
                                        color: "grey_600",
                                        children: translations/* default */.Z[languageCode]["Email not confirmed"]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        fontSize: "h3",
                                        lineHeight: "h3",
                                        fontWeight: "medium",
                                        color: "grey_400",
                                        mt: "s",
                                        children: translations/* default */.Z[languageCode]["Email activation failed"]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(btn/* default */.Z, {
                        onClick: onClose,
                        style: {
                            p: 2,
                            mr: "m"
                        },
                        type: "button",
                        label: translations/* default */.Z[languageCode].Close
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var email_confirmed_error = (EmailConfirmedError);


/***/ }),

/***/ 83213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_email_confirmed; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var dist_index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./src/theme/card/index.js
var card = __webpack_require__(16850);
// EXTERNAL MODULE: ./src/theme/buttons/btn.js
var btn = __webpack_require__(84146);
;// CONCATENATED MODULE: ./src/theme/icons/email-confirmed.js


var emailConfirmed = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "160",
        height: "127",
        viewBox: "0 0 160 127",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter0_ddd557kdn003)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "24.2568",
                    y: "24.0234",
                    width: "111.219",
                    height: "77.0488",
                    rx: "10",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.4",
                d: "M135.644 94.1196C136.068 92.9718 87.4522 56.1444 87.4522 56.1444C81.3658 51.6384 78.1647 51.5675 72.1461 56.1444C72.1461 56.1444 23.6012 92.942 24.0098 94.0741L24 94.0824C24.005 94.0923 24.0131 94.0991 24.0199 94.1081C24.4315 95.2338 25.0303 96.2814 25.791 97.2064C26.1123 97.5972 26.4995 97.9246 26.8719 98.265L26.8538 98.279C26.8835 98.3054 26.923 98.3177 26.9526 98.3442C28.5309 99.7567 30.5213 100.672 32.7324 100.933C32.7671 100.937 32.7951 100.955 32.8297 100.959H32.9632C33.2994 100.991 33.619 101.072 33.9632 101.072H125.743C130.262 101.072 134.091 98.221 135.612 94.224C135.63 94.1943 135.658 94.1728 135.674 94.1422L135.644 94.1196Z",
                fill: "#4CADBA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.6",
                d: "M79.8664 51.9181L24.2568 93.7602V34.484C24.2568 28.7062 28.9245 24.0234 34.6836 24.0234H125.049C130.808 24.0234 135.476 28.7062 135.476 34.484V93.7602L79.8664 51.9181Z",
                fill: "#B0DAE0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.9053 30.8483L72.384 68.2611C78.3765 72.6975 81.5283 72.7675 87.4543 68.2611L134.858 30.9076C134.036 29.412 132.805 28.2304 131.397 27.2882L132.049 26.7756C130.457 25.3222 128.423 24.3801 126.165 24.1367L33.5712 24.14C31.3195 24.3801 29.282 25.3255 27.6939 26.7756L28.3411 27.2819C26.9493 28.2109 25.7294 29.3721 24.9053 30.8483Z",
                fill: "#EDECE6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.8896 30.9236C24.4727 32.054 72.3393 68.3137 72.3393 68.3137C78.3318 72.75 81.4836 72.8201 87.4096 68.3137C87.4096 68.3137 135.206 32.0833 134.804 30.9685L134.814 30.9604C134.809 30.9506 134.801 30.9442 134.794 30.9352C134.389 29.8268 133.799 28.7953 133.05 27.8846C132.734 27.4997 132.353 27.1775 131.986 26.8422L132.004 26.8284C131.975 26.8024 131.936 26.7901 131.907 26.7641C130.353 25.3735 128.393 24.4727 126.216 24.2156C126.182 24.2114 126.155 24.1937 126.121 24.1895H125.989C125.658 24.1578 125.343 24.0781 125.004 24.0781H34.639C30.1893 24.0781 26.4192 26.8856 24.9221 30.8208C24.9042 30.8501 24.8767 30.8713 24.8604 30.9013L24.8896 30.9236Z",
                fill: "#E0F1F3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter1_ddd555nnvvcp8)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M151.614 95.6477C151.614 86.3693 144.092 78.8477 134.814 78.8477C125.535 78.8477 118.014 86.3693 118.014 95.6477V95.7564C118.014 105.035 125.535 112.556 134.814 112.556C144.092 112.556 151.614 105.035 151.614 95.7564V95.6477Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M134.814 81.3477C126.894 81.3477 120.414 87.8277 120.414 95.7477C120.414 103.668 126.894 110.148 134.814 110.148C142.734 110.148 149.214 103.668 149.214 95.7477C149.214 87.8277 142.734 81.3477 134.814 81.3477ZM134.814 107.268C128.464 107.268 123.294 102.098 123.294 95.7477C123.294 89.3973 128.464 84.2277 134.814 84.2277C141.164 84.2277 146.334 89.3973 146.334 95.7477C146.334 102.098 141.164 107.268 134.814 107.268ZM141.424 89.3829L131.934 98.8725L128.204 95.1573L126.174 97.1877L131.934 102.948L143.454 91.4277L141.424 89.3829Z",
                fill: "#0A8EA0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_ddd557kdn003",
                        x: "16.2568",
                        y: "20.0234",
                        width: "127.219",
                        height: "93.0488",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "0.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_dropShadow",
                                result: "effect2_dropShadow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_dropShadow",
                                result: "effect3_dropShadow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect3_dropShadow",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter1_ddd555nnvvcp8",
                        x: "110.014",
                        y: "74.8477",
                        width: "49.6",
                        height: "49.7087",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "0.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect1_dropShadow",
                                result: "effect2_dropShadow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in2: "effect2_dropShadow",
                                result: "effect3_dropShadow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect3_dropShadow",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var email_confirmed = (emailConfirmed);

// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
;// CONCATENATED MODULE: ./src/components/email-confirmed/index.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  width: 100%;\n  min-height: 100%;\n\n  & > div > .row-2 {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  & > div > .row-2 > div {\n    display: flex;\n    flex-direction: row;\n  }\n\n  & > div > .row-2 > div > .col-2 {\n    display: flex;\n    flex-direction: column;\n    max-width: 360px;\n    justify-content: center;\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f91c24da-0"
})(_templateObject(), index_esm/* flexbox */.GQ, index_esm/* space */.Dh, (0,dist_index_esm/* themeGet */.R)("space.m"));
var Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-f91c24da-1"
})(_templateObject1(), index_esm/* typography */.cp, index_esm/* color */.$_, index_esm/* space */.Dh);
function EmailConfirmed(param) {
    var onClose = param.onClose;
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.Z, {
            width: "100%",
            minWidth: "240px",
            bg: "white",
            borderColor: "primary_100",
            py: "l",
            px: "s",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(email_confirmed, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        fontSize: "h2",
                                        lineHeight: "h2",
                                        fontWeight: "bold",
                                        color: "grey_600",
                                        children: translations/* default */.Z[languageCode]["Email confirmed"]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        fontSize: "h3",
                                        lineHeight: "h3",
                                        fontWeight: "medium",
                                        color: "grey_400",
                                        mt: "s",
                                        children: translations/* default */.Z[languageCode]["Your email is confirmed"]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(btn/* default */.Z, {
                        onClick: onClose,
                        style: {
                            p: 2,
                            mr: "m"
                        },
                        type: "button",
                        label: translations/* default */.Z[languageCode].Close
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var components_email_confirmed = (EmailConfirmed);


/***/ })

}]);